<template>
  <div>
    <SeoLink
      class="listRank-container"
      :to="{ name: 'rank', query: { qid: info.qid } }"
      :guard="handleRankClick"
    >
      <div class="join-number">
        <div>
          排行榜<span
            class="only-see"
            v-if="
              ((info.is_vip || info.is_admin || info.is_owner) &&
                !info.show_rank) ||
                info.hide_score
            "
            >丨仅管理员可见</span
          >
        </div>
        <div class="blue-arror pointer position-r" @click.stop="toWx" v-if="(info.is_vip || info.is_admin || info.is_owner) && !isInApp">
          <img
            class="icon-search"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-01-21/2f273eaa6806b74358b932117c0b9ac9.svg"
            alt=""
          />
          <img class="dlown-icon" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-01-02/4a82dbf41f0c4164fb831840b0d76304.svg" alt="">
          <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + info.qid" />
        </div>
      </div>
      <div
        :class="index < 3 ? 'listRank-bg listRank' : 'listRank'"
        v-for="(item, index) in rankLists"
        :key="index"
      >
        <div class="i_1">
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220329/9461bb07da8b5bb6ee498b897827e47f.png"
            v-if="item.rank == 1"
          />
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220328/ae55b620eb805e7a6fc4799d3f4f12be.png"
            v-else-if="item.rank == 2"
          />
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220328/824fe9c5000c0e0a2590fb0dc9f05285.png"
            v-else-if="item.rank == 3"
          />
          <label v-else>{{ item.rank }}</label>
        </div>
        <div class="i_2">
          <img
            class="i_border"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220328/16335c5a577101031827c607d23ffb0f.png"
            v-if="index == 0"
          />
          <img
            :class="
              index == 2 || index == 1 ? 'border-white avatar ' : 'avatar'
            "
            :src="item.avatar"
          />
        </div>
        <div class="i_3">
          <div class="name">{{ item.alias }}</div>
          <div class="time" v-if="info.temp != 2">{{ item.t_add }}</div>
        </div>
        <div class="i_4" v-if="info.temp == 2">
          <div class="score">{{ item.score }}</div>
          <div>{{ item.total_days }}天</div>
        </div>
        <div class="i_4" v-else>
          <div class="score">{{ item.score }}</div>
          <div v-if="info.temp != 5">{{ item.time }}</div>
        </div>
      </div>
      
      <div v-if="info.joined > 3 && info.rank_limit > 3" class="load-more">
        加载更多<img
          class="load-icon"
          alt=""
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/0b288c3890a38b88153dc97cf8ba5b66.png"
        />
      </div>
    </SeoLink>
  </div>
</template>
<script>
import { getToken } from "@/utils/common";
import SeoLink from "@/components/SeoLink.vue";
import WxLink from "@/components/wxLink.vue";

export default {
  data() {
    return{
      wxPath: "/pages/detail/detail?qid=",
    }
  },
  props: ["rankLists", "info", "isMobile", "isWeixin", "isInApp"],

  methods: {
    toWx() {
      this.$emit("toMessage");
    },
    handleRankClick() {
      if (
        wemeet.app.isTMWebview() ||
        (this.info.enterprise_vip && this.info.unionid)
      ) {
        return true;
      } else {
        if (
          !this.isWeixin &&
          this.isMobile &&
          !this.info.unionid &&
          !getToken()
        ) {
          this.$emit("getLoginCode", true);
          return false;
        }
        if (
          !this.isWeixin &&
          !this.isMobile &&
          !this.info.unionid &&
          !getToken()
        ) {
          this.$emit("getLoginCode");
          return false;
        }
        if (!this.info.enterprise_vip) {
          this.$emit("handleVipTip");
          return false;
        }
        return true;
      }
    }
  },
  components: {
    SeoLink,
    WxLink
  }
};
</script>
<style lang="scss" scoped>
.listRank-container {
  display: block;
}
.join-number {
  height: 45px;
  font-size: 15px;
  color: #333;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  background-color: #fff;
  margin-top: 10px;
}
.only-see {
  color: #999999;
  font-size: 12px;
}
.blue-arror-img {
  width: 8px;
  height: 12px;
  margin-left: 4px;
}
.blue-arror {
  display: flex;
  align-items: center;
  align-items: center;
  color: #999999;
  line-height: 1;
  font-size: 14px;
}
.nolistRank {
  text-align: center;
  font-size: 13px;
  line-height: 20px;
  text-align: center;
  color: #999999;
  background-color: #ffffff;
  padding: 10px 0 15px;
}

.nolistRank img {
  width: 70px;
  height: 70px;
  margin-bottom: 10px;
}

.listRank {
  height: 75px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  padding-bottom: 15px;
}
.listRank:first-child {
  padding-top: 0;
}
.listRank-bg {
  background: #ffffff;
  border-bottom: 0;
  height: 50px;
}
.i_1 {
  /* min-width: 80); */
  padding-left: 15px;
  white-space: nowrap;
  padding-right: 5px;
  text-align: center;
  margin-top: 7px;
}
.i_1 img {
  width: 27px;
  height: 27px;
}

.i_2 {
  position: relative;
}
.i_2 .avatar {
  position: relative;
  z-index: 2;
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  margin-right: 15px;
  margin-left: 7px;
  margin-top: 7px;
  object-fit: cover;
}

.border-white {
  border: 2px solid #fff;
}
.i_border {
  position: absolute;
  z-index: 1;
  width: 54px;
  height: 54px;
}

.i_3 {
  flex: 1;
  margin-top: 7px;
}
.i_3 .name {
  font-size: 14px;
  line-height: 21px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.i_3 .time {
  font-size: 12px;
  line-height: 18px;
  color: #999;
  margin-bottom: 0;
}

.i_4 {
  width: 80px;
  font-size: 12px;
  color: #666;
  text-align: center;
}
.i_4 .score {
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
  color: #1890ff;
}
.load-more {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  height: 19px;
  background: #ffffff;
  padding-bottom: 15px;
  color: #999999;
  cursor: pointer;
}
.load-icon {
  width: 8px;
  height: 12px;
  margin-left: 4px;
  transform: rotate(90deg);
}
.dlown-icon {
  width: 20px;
  height: 20px;
  margin-left: 15px;
}
.icon-search {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/rankList.vue